
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 13h2V8.8l1.6 1.6L14 9l-4-4-4 4 1.4 1.4L9 8.8V13zm-7 3c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 010 14V2C0 1.45.196.98.588.587A1.926 1.926 0 012 0h6l2 2h8c.55 0 1.02.196 1.413.587C19.803 2.98 20 3.45 20 4v10c0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0118 16H2z"}})])
          )
        }
      }
    